import {
    createRouter,
    createWebHistory
} from "vue-router";
import config from '@/methods/config'

const routes = [{
    path: '/',
    redirect: '/index',
}, {
    path: "/index",
    meta: {
        title: "首页",
    },
    component: () => import("../views/index.vue"),
}, {
    path: "/info",
    meta: {
        title: "开盖中奖",
    },
    component: () => import("../views/info.vue"),
}, ];
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(savedPosition) {
        window.scrollTo(savedPosition.x, savedPosition.y);
    },
});


// 确保在内页时刷新页面导致vuex中存储的权限列表没了无法判断
router.beforeEach((to, form, next) => {
    window.scrollTo(0, 0);
    let query = to.query
    if (Object.keys(query).length) {
        for (let key in query) {
            localStorage.setItem(key, query[key])
        }
    }
    let token = localStorage.getItem('token')
    if (token) {
        next()
    } else {
        let href = window.location.hostname + '/tea/index'
        // let href = window.location.href
        window.location.href = config.host + '/tea/api/login/oauth?rollback_url=' +
            encodeURIComponent(href)
    }
})

router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    if (isChunkLoadFailed) {
        location.reload();
    }
});

router.afterEach((to) => {
    console.log(window.location.href)
    if (/iphone|ipad/i.test(navigator.userAgent)) {
        if (!window.entryUrl) {
            window.entryUrl = window.location.href; // iOS记录入口URL‌:ml-citation{ref="2,4" data="citationList"}
        }
    } else {
        window.entryUrl = window.location.href; // Android用当前URL‌:ml-citation{ref="5,6" data="citationList"}
    }
});
export default router;